export enum RoleType {
  Employee = 'employee',
  Manager = 'manager',
  Executive = 'executive',
  SecondAdmin = 'second_admin',
  CEO = 'ceo',
  CompanyAdmin = 'company_admin',
}
